import { render, staticRenderFns } from "./ReservaNew.vue?vue&type=template&id=4826585a&"
import script from "./ReservaNew.vue?vue&type=script&lang=js&"
export * from "./ReservaNew.vue?vue&type=script&lang=js&"
import style0 from "./ReservaNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports